import { Button, Checkbox, Form, Input, Radio } from 'antd';
import React, { useEffect, useState } from 'react';
import rzr from '../../../Assets/razorpay-logo.png';
import PaymentInfoBanner from '../../../Assets/payment-info-banner.png';
import PaymentInfoBannerMobile from '../../../Assets/payment-info-banner-mobile.png';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import { useSelector } from 'react-redux';
import Loading from 'react-fullscreen-loading';
import { OrbitProgress } from 'react-loading-indicators';
const RequiredMark = (val) => {
  // RequiredMark.propTypes = {
  //   label: PropTypes.string,
  //   required: PropTypes.bool,
  // };

  return (
    <>
      {val}
      {<span style={{ color: 'red' }}>*</span>}
    </>
  );
};

const Payment = ({ form, onFinish, tickets, freeLoading, questions }) => {
  const [ticketCount, setTicketCount] = useState(0);
  const isMobile = useMediaQuery({ maxWidth: 600 });
  const { loading } = useSelector((state) => state.cart);
  Payment.propTypes = {
    form: PropTypes.object,
    onFinish: PropTypes.func,
    tickets: PropTypes.array,
  };

  useEffect(() => {
    let ticketCount = 0;
    tickets.forEach((ticket) => {
      ticketCount += ticket.qty;
    });
    setTicketCount(ticketCount - 1);
  }, [tickets]);

  return (
    <div>
      <Form
        layout="vertical"
        form={form}
        requiredMark={RequiredMark}
        onFinish={onFinish}
      >
        <div className="order-summary-container square-container border-radius-14">
          <div className="square-heading" style={{ marginBottom: '32px' }}>
            Ticket Details
          </div>
          <div>
            <div className="ticket-detail-form-field">
              <div className="ticket-detail-form-sub-wrapper">
                <Form.Item label="Full Name" name="name" required>
                  <Input placeholder="Enter your full name" />
                </Form.Item>
              </div>
            </div>
            <div className="ticket-detail-form-field">
              <div className="ticket-detail-form-sub-wrapper ">
                <Form.Item
                  label="Phone Number"
                  name="phone"
                  required
                  className="no-margin-mobile"
                  // style={{ marginBottom: 0 }}
                >
                  <Input placeholder="Enter your phone number" />
                </Form.Item>
              </div>
              <div className="ticket-detail-form-helper">
                (Please mention registered phone number for ticket access in
                app)
              </div>
            </div>
            <div className="ticket-detail-form-field">
              <div className="ticket-detail-form-sub-wrapper">
                <Form.Item
                  label="Email Address"
                  name="email"
                  required
                  style={{ marginBottom: 0 }}
                >
                  <Input placeholder="Enter your email address" />
                </Form.Item>
              </div>
              <div className="ticket-detail-form-helper">
                (This email address will receive the e-tickets)
              </div>
            </div>
          </div>
        </div>
        {ticketCount > 0 && (
          <div className="order-summary-container square-container border-radius-14">
            <div className="square-heading" style={{ marginBottom: '32px' }}>
              Attendee Details
            </div>
            <div>
              {Array.from({ length: ticketCount }).map((_, index) => (
                <>
                  <div
                    style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}
                  >
                    Attendee {index + 1}
                  </div>
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 12 }}
                  >
                    <div className=" ticket-detail-form-sub-wrapper">
                      <Form.Item
                        label="Full Name"
                        name={`ticket[${index}].name`}
                        required
                      >
                        <Input placeholder="Enter your full name" />
                      </Form.Item>
                    </div>
                  </div>
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 12 }}
                  >
                    <div className=" ticket-detail-form-sub-wrapper">
                      <Form.Item
                        label="Phone Number"
                        name={`ticket[${index}].phone`}
                        required
                      >
                        <Input placeholder="Enter your phone number" />
                      </Form.Item>
                    </div>
                  </div>
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 12 }}
                  >
                    <div className=" ticket-detail-form-sub-wrapper">
                      <Form.Item
                        label="Email Address"
                        name={`ticket[${index}].email`}
                        required
                      >
                        <Input placeholder="Enter your email address" />
                      </Form.Item>
                    </div>
                  </div>
                </>
              ))}
            </div>
          </div>
        )}
        {questions && questions.length > 0 && (
          <div className="order-summary-container square-container border-radius-14">
            <div className="square-heading">Questions</div>
            <div>
              {questions.map((item, index) => (
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: 12 }}
                  key={item._id}
                >
                  <div className=" ticket-detail-form-sub-wrapper">
                    <Form.Item
                      label={item.question}
                      name={`question[${item._id}]`}
                      required
                    >
                      {item.type == 'text' && <Input placeholder="" />}
                      {item.type == 'singleChoice' && (
                        <Radio.Group>
                          {item.options.map((option) => (
                            <Radio value={option} key={option}>
                              {option}
                            </Radio>
                          ))}
                        </Radio.Group>
                      )}
                      {item.type == 'multipleChoice' && (
                        <Checkbox.Group>
                          {item.options.map((option) => (
                            <Checkbox value={option} key={option}>
                              {option}
                            </Checkbox>
                          ))}
                        </Checkbox.Group>
                      )}
                    </Form.Item>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        <div className="order-summary-container square-container border-radius-14">
          <div
            className="square-heading"
            style={{ marginBottom: isMobile ? '16px' : '32px' }}
          >
            Payment Method
          </div>
          <div className="payment-type-container">
            <Radio checked={true}>
              <div style={{ marginLeft: 12 }}>
                <div className="payment-type">Razorpay</div>
                <div className="payment-type-helper">
                  Secure online payment through the Razorpay portal
                </div>
              </div>
            </Radio>
            <img src={rzr} alt="rzrPay" width="135px" />
          </div>
          <img
            src={isMobile ? PaymentInfoBannerMobile : PaymentInfoBanner}
            alt="paymentBanner"
            style={{ width: '100%', marginTop: 24 }}
          />
        </div>
        <div className="book-now-cta-container">
          {loading || freeLoading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '8px',
              }}
            >
              <OrbitProgress color="#ce202f" size="small" />
            </div>
          ) : (
            <Button
              htmlType="submit"
              className="book-now-btn border-radius-14"
              disabled={loading || freeLoading}
            >
              {' '}
              Book Now
            </Button>
          )}
        </div>
      </Form>
    </div>
  );
};

export default Payment;
